import { Form, InputField } from '@welbe/web-design-system';
import { Button } from '@welbe/design-system';
import {
	LinkRecoverPassword,
	Wrapper,
	WrapperSignIn,
	WrapperSignUp,
} from './SignIn.styles';
import React, { useEffect, useState } from 'react';
import { useAuth } from 'hooks/useAuth';
import { useNavigate } from 'react-router-dom';
import Analytics from 'helpers/analytics';

type AccountTypes = {
	username: string;
	password: string;
};

export const SignIn = () => {
	const navigate = useNavigate();

	const [hasError, setError] = useState<boolean>(false);
	const [errorMessage, setErrorMessage] = useState<string>('');

	const { signIn, isLoading, errorInfo } = useAuth();

	const handleSubmit = (values: AccountTypes) => {
		setError(false);
		const { username, password } = values;
		if (username && password) {
			signIn(values);
		} else {
			setError(true);
			setErrorMessage('* Complete todos los campos');
		}
	};

	useEffect(() => {
		if (errorInfo) {
			setErrorMessage(errorInfo);
		}
	}, [errorInfo]);

	return (
		<Form
			id="authentication-form"
			onSubmit={(event: AccountTypes) => handleSubmit(event)}
		>
			<Wrapper>
				<InputField
					id="username"
					placeholder="Ingrese el correo electrónico"
					error={Boolean(errorInfo) || hasError}
					preventErrorMessage={
						errorInfo === 'Nombre de usuario o contraseña incorrecta'
					}
				/>
				<InputField
					id="password"
					placeholder="Introducir la contraseña"
					className="password-input"
					type="password"
					errorText={Boolean(errorInfo) || hasError ? errorMessage : ''}
					error={Boolean(errorInfo) || hasError}
				/>
				<LinkRecoverPassword to="/password-recover">
					¿Olvidaste tu contraseña?
				</LinkRecoverPassword>
			</Wrapper>

			<WrapperSignIn>
				<Button
					type="submit"
					id="submit-button"
					width="100%"
					loading={isLoading}
				>
					Entrar
				</Button>
			</WrapperSignIn>
			<WrapperSignUp>
				<p>
					¿Todavía no tienes una cuenta?{' '}
					<a
						onClick={() => {
							Analytics.track('login', 'Initiated Registration');
							navigate('/register');
						}}
					>
						Registrarse
					</a>
				</p>
			</WrapperSignUp>
		</Form>
	);
};
